import React from 'react'

export default function BookPackageLoading() {
  // Create an array of 6 items to show skeleton loaders
  const skeletonItems = Array(6).fill(null)
  
  return (
    <div className="grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-2">
      {skeletonItems.map((_, index) => (
        <div key={index} className="relative border-b py-4 animate-pulse">
          <div className="relative flex items-center">
            {/* Icon skeleton */}
            <div className="relative mr-3">
              <div className="bg-gray-200 w-[8rem] h-[8rem] rounded-md"></div>
              <div className="absolute left-4 top-6 h-6 w-6 rounded-md bg-gray-300"></div>
            </div>
            
            {/* Content skeleton */}
            <div className="flex flex-1 flex-col">
              <div className="h-6 w-3/4 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
            </div>
            
            {/* Menu button skeleton */}
            <div className="absolute right-0 top-0">
              <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}